module.exports = __webpack_public_path__ + "dec0f474.jpeg";